import { render, staticRenderFns } from "./addshopCategory.vue?vue&type=template&id=1183de7c&scoped=true"
import script from "./addshopCategory.vue?vue&type=script&lang=js"
export * from "./addshopCategory.vue?vue&type=script&lang=js"
import style0 from "./addshopCategory.vue?vue&type=style&index=0&id=1183de7c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1183de7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1183de7c')) {
      api.createRecord('1183de7c', component.options)
    } else {
      api.reload('1183de7c', component.options)
    }
    module.hot.accept("./addshopCategory.vue?vue&type=template&id=1183de7c&scoped=true", function () {
      api.rerender('1183de7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/shopList/addshopCategory.vue"
export default component.exports